const redpacketInitialState = {
  info: null,
  gameConfig: null,
  coupons: null,
  notice: null,
  loadStatus: 0,
  saveStatus: 0,
  currentView: 0,
};

function redpacketReducer(state = redpacketInitialState, action) {
  switch (action.type) {
    case 'LOAD_REDPACKET_HOME': {
      return {
        ...state,
        loadStatus: 1,
      };
    }
    case 'LOAD_REDPACKET_HOME_COMPLETION': {
      const { error, data } = action;

      if (error) {
        return { ...state, loadStatus: 0 };
      }

      return {
        ...state,
        info: data,
        currentView: 0,
        loadStatus: 2,
      };
    }

    case 'LOAD_REDPACKET_CONFIG': {
      return {
        ...state,
        loadStatus: 1,
      };
    }
    case 'LOAD_REDPACKET_CONFIG_COMPLETION': {
      const { error, data } = action;

      if (error) {
        return { ...state, loadStatus: 0 };
      }

      return {
        ...state,
        gameConfig: data,
        loadStatus: 2,
      };
    }
    case 'LOAD_REDPACKET_RESULT': {
      return {
        ...state,
        saveStatus: 1,
      };
    }
    case 'LOAD_REDPACKET_RESULT_COMPLETION': {
      const { error, data } = action;
      const { coupons, ...info } = data;
      if (error) {
        return {
          ...state,
          saveStatus: 0,
          currentView: 0,
        };
      }
      return {
        ...state,
        coupons,
        info,
        saveStatus: 2,
        currentView: 2,
      };
    }
    case 'RECEIVE_REDPACKET_COUPON': {
      return {
        ...state,
        saveStatus: 1,
      };
    }
    case 'RECEIVE_REDPACKET_COUPON_COMPLETION': {
      const { error, data } = action;
      const { coupons, ...info } = data;

      if (error) {
        return {
          ...state,
          saveStatus: 0,
        };
      }

      return {
        ...state,
        coupons,
        info,
        saveStatus: 2,
        currentView: 2,
      };
    }

    case 'LOAD_REDPACKET_NOTICE_COMPLETION': {
      const { error, data } = action;

      if (error) {
        return state;
      }
      return {
        ...state,
        notice: data,
      };
    }
    case 'UPDATE_REDPACKET_VIEW': {
      const { viewId } = action;
      return {
        ...state,
        currentView: viewId,
      };
    }

    default:
      return state;
  }
}
export default redpacketReducer;
